export function formatEMSDateHour(date) {
  try {
    const d = typeof date === 'string' ? new Date(date) : date;

    if (isNaN(d)) return date || '-';

    // Get parts
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = String(d.getFullYear());
    const hours = String(d.getHours()).padStart(2, '0');
    const minutes = String(d.getMinutes()).padStart(2, '0');

    return `${day}/${month}/${year} ${hours}:${minutes}h`;
  } catch {
    return date || '-';
  }
}

export function formatDate(date, hour = null) {
  try {
    let date_string = date;
    if (typeof date === 'object') {
      const corr_date = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
      date_string = corr_date.toISOString();
    }
    if (hour) return date_string.slice(0, 10) + ' ' + hour;
    return date_string.slice(0, 10) + ' ' + date_string.slice(11, 16);
  } catch {
    return 'wrong date format';
  }
}

export function formatSimpleDateHour(date) {
  try {
    if (typeof date === 'object') {
      const corr_date = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
      date = corr_date.toISOString();
    }
    const formattedDate = date.slice(0, 10) ?? '';
    const formattedHour = date.slice(11, 16) ?? '';
    return { date: formattedDate, hour: formattedHour };
  } catch {
    return { date: '', hour: '' };
  }
}

export function toDate(dateString) {
  if (typeof dateString !== String) return dateString;
  const time = dateString.split(' ');
  const timeStr = `${time[0]}T${time[1]}`;
  const date = new Date(timeStr);
  return date;
}

export function daysInMonth(month, year) {
  return new Date(year, month, 0).getDate();
}

/** YYYY-MM-DD from ISO string or Date (UTC, matches formatSimpleDateHour for ISO strings). */
export function toIsoDateKey(date) {
  if (!date) return '';
  if (typeof date === 'string') return date.slice(0, 10);
  const parsed = new Date(date);
  return Number.isNaN(parsed.getTime()) ? '' : parsed.toISOString().slice(0, 10);
}

export function getUtcDateKeyWithOffset(dayOffset = 0) {
  const date = new Date();
  date.setUTCDate(date.getUTCDate() + dayOffset);
  return date.toISOString().slice(0, 10);
}
